import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Switch, Route, Redirect } from 'react-router-dom';

import Layout from '../Sections/Layout';

import NewGroup from './NewGroup';
import MyGroup from './MyGroup';
import GroupMembership from './GroupMembership';

const Group = (props) => {
  return (
    <Layout {...props}>
      <Switch>
        <Redirect
          from={`${process.env.PUBLIC_URL}/groups`}
          to={`${process.env.PUBLIC_URL}/groups/my-groups`}
          exact
        />
        <Route
          path={`${process.env.PUBLIC_URL}/groups/new-group`}
          component={NewGroup}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/groups/my-groups`}
          component={MyGroup}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/groups/membership`}
          component={GroupMembership}
        />
      </Switch>
    </Layout>
  );
};

const mapStateToProps = (state) => ({
  app: state.app,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Group);
